import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import './FooterNewChanges.css';

const FooterNewChanges = () => {
  const imgCDNUrl1 = process.env.REACT_APP_CDN ;
    const imgCDNUrl = process.env.REACT_APP_CDN_LINK + "myanglai/wordpress/";
  // Get current year dynamically
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="atf_colophon">
      <div className="atf_bar_footer">
        <Container fluid className="atf_bar_content">
          <Row className="atf_row">
          <Col xs={12} lg={12} className="disclaimer">
                    <p>The $ANGL Token is issued by ANGL, Inc. and is not affiliated with <a href="https://www.angeltwin.com/" target="_blank" rel="noopener noreferrer" className="disclaimer-link">Angel Twin.</a></p>
                    </Col>
            <Col xs={12} md={4} className="atf_logo_col">
              <img 
             src={imgCDNUrl1 + 'angl-token-launch/images/angl-token-animation-3d.gif'}
                alt="Angel Twin Logo" 
                className="atf_logo_image"
              />
            </Col>
            
            <Col xs={12} md={4} className="atf_copyright_col">
              <div className="atf_copyright_text">
                © {currentYear} ANGL Inc. All rights reserved
              </div>
            </Col>
            
            <Col xs={12} md={4} className="atf_links_col">
              <div className="atf_links_container">
                <Link to="/privacy" className="atf_link">
                  Privacy Policy
                </Link>
                <Link to="/terms" className="atf_link">
                  Terms of Use
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default FooterNewChanges;